import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { CloseIcon } from '../CloseIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ExcursionModal(_ref) {
  let {
    tourUrl,
    onClose
  } = _ref;
  return /*#__PURE__*/_jsxs(ModalFullscreen, {
    escape: true,
    theme: "black",
    open: true,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx("iframe", {
      frameBorder: 0,
      src: tourUrl,
      width: "100%",
      height: "100%",
      allowFullScreen: true,
      sandbox: "allow-scripts allow-same-origin allow-popups allow-downloads"
    }), /*#__PURE__*/_jsx(CloseIcon, {
      onClick: onClose
    })]
  });
}